<template>
  <div class="loading-bg" v-show="loading">
    <div class="loading-content">
      <div class="spinner"></div>
      <p v-if="!!text">{{text}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    text: {
      type: String
    }
  }
}
</script>
